import Swiper from 'swiper';
import SameSizedCards from '../modules/same_sized_cards';
import Form from '../modules/forms/form';
import copyToClipboard from '../util/copyToClipboard';
import debounce from '../util/debounce';
import Components from '../autoload/_components';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';


export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        this.setDefaults();
        Form.init();
        SameSizedCards.init();
        Components.init();
        this.addEvents();
        this.initSwipers();
        this.initTags();
        this.initMagnificPopup();
        lazySizes.init();


    },
    setDefaults() {
        this.jHtml = $(document.body).parent();
    },
    addEvents() {
        $('.location-tooltip').on('hover', function() {
            $(this).addClass('tooltip');
            $(this).html('<span class="tooltiptext">This will redirect to googlemap</span>');
          
        });

        $('.jscareerUploadResume').change(function(e) {
            var fileName = e.target.files[0].name;
            $('.jsCareerUploadFilename').html(fileName);
        });

        $(window).scroll(debounce($.proxy(this._onWinScroll, this), 100));

        $('.jsReferralGotoDashboard').on('click', function() {
            location.href = 'https://carbonateapp.com/dashboard';
        });
        if ($('.user-guide-detail__steps').length > 0) {
            $('.user-guide-detail__steps').magnificPopup({
                delegate: '.user-guide-detail__step-img-wrapper', // child items selector, by clicking on it popup will open
                type: 'image',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '<span class="mfp-counter">Step %curr%</span>', // markup of counter
                },
                image: {
                    // options for image content type
                    titleSrc: function() {
                        return '';
                    },
                },
                midClick: true,

                // Delay in milliseconds before popup is removed
                removalDelay: 300,

                // Class that is added to popup wrapper and background
                // make it unique to apply your CSS animations just to this exact popup
                mainClass: 'mfp-fade',

                // other options
            });
        }

        // $('.signup-exit').addClass('d-none');

        // $(function () {
        //     $('.location-tooltip .tooltip-title').tooltip();
        //   })
        $('.jsLeftNavLink').on('change', function(e) {
            var jTarget = $(e.delegateTarget);
            location.href = jTarget.find(':selected').data('href');
        });

        $('.jsViewmore').click(function() {
            // e.preventDefault();
            // var jTarget = $('#myDiv');
            $('html, body').animate({ scrollTop: $('.jNextDiv').position().top }, 'slow');

        });


        $('#message_contact').on('change',function(e){
            var name = e.currentTarget.value;
            e.currentTarget.value = name.replace(/\s+/g,' ');
        });

        $('#name__contact').on('change',function(e){
            var name = e.currentTarget.value;
            e.currentTarget.value = name.replace(/\s+/g,' ');
        });


        this._checkScrollAndUpdateTop();
        if ($(window).width() < 767) {
            $('#scroll__top').click(function() {
                // e.preventDefault();
                $('html, body').animate({
                    scrollTop: '0',
                }, 400);
            });
        } else {
            $('#scroll__top').hide();
        }
        $('.thanks__urlcopy').on('click', function() {
            copyToClipboard($('.thanks__url').html().trim());
            $('.thanks__urlcopy').addClass('active');

            setTimeout(function() {
                $('.thanks__urlcopy').removeClass('active')
            }, 3000);

        });
        // Add Google anlytics code here
        // $('.jsAnalytics').click(function() {
        //   var buttonText = $(this).text();
        //   var pageTitle = $(this).attr('data-title');
        //   // ga('send', 'event', pageTitle, 'click', buttonText);
        // });
    },
    initMagnificPopup() {


        $('.open-popup-link').magnificPopup({
            type: 'inline',
            midClick: true,
            mainClass: 'mfp-fade',
        });
    },
    initSwipers() {
        // Horizontal Swipers
        new Swiper($('.jsSwiper.jsHorizontalSwiper')[0], {
            autoplay: {
                delay: 1000000,
            },
            slidesPerView: 'auto',
            loop: false,
            speed: 600,
            freeMode: true,
            observer: true,
            observeParents: true,
        });
    },
    initTags() {
        if ($('.jsSelectMultiple.jsSelectTags').length > 0) {
            // let select2Instance;
            //$('.jsSelectMultiple.jsSelectTags').select2();

            $('.jsSelectMultiple.jsSelectTags').select2({
                multiple: true,
                createTag: function() {
                    return null;
                },
            });
            // Patch to clear the selections in the begining
            // select2Instance.val(null).trigger('change');
        }
    },

    

    _onWinScroll: function() {
        this._checkScrollAndUpdateTop();
    },
    _checkScrollAndUpdateTop: function() {
        if ($(window).scrollTop() > 300) {
            if ($(window).width() < 767) {
                $('#scroll__top').show();
            }
        } else {
            $('#scroll__top').hide();
        }
    },

    


};

  



// WEBPACK FOOTER //
// ./scripts/routes/common.js